import axios from 'axios'
import {
    FrontGlobalParametersDetailResponse,
    IdentifierRegexResponse,
    IdentifierTypeResponse,
    LaboratoryConfigurationResponse,
    UserappPatchRequest,
    UserInformationDetailResponse
} from '@/api/resources/common/initialization/common-initialization.dto'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonInitializationService {
    // Returns the list of all active identifier regular expressions
    async getIdentifierRegexes(): Promise<IdentifierRegexResponse[]> {
        const response = await axios.get<IdentifierRegexResponse[]>('common/identifierRegexes')
        return response.data
    }

    // returns the global parameters of the application
    async getGlobalParameters(): Promise<FrontGlobalParametersDetailResponse> {
        const response = await axios.get<FrontGlobalParametersDetailResponse>('globalParameters')
        return response.data
    }

    // Returns the list of entities by identifier
    async getIdentifierTypes(): Promise<IdentifierTypeResponse[]> {
        const response = await axios.get<IdentifierTypeResponse[]>('identifierTypes')
        return response.data
    }

    // Return the configuration for each laboratory, including operations, modules and sections for the current user
    async getLaboratoriesConfiguration(): Promise<LaboratoryConfigurationResponse[]> {
        const response = await axios.get<LaboratoryConfigurationResponse[]>('laboratoriesConfiguration')
        return orderBy(response.data, configuration => TextNormalization.removeDiacritics(configuration.laboratory.labName), ['asc'])
    }

    // returns the logged in user information
    async getUserInformation(): Promise<UserInformationDetailResponse> {
        const response = await axios.get<UserInformationDetailResponse>('userInformation')
        return response.data
    }

    // patches logged in user
    async patchUserInformation(userappPatchRequest: UserappPatchRequest): Promise<UserInformationDetailResponse> {
        const response = await axios.patch<UserInformationDetailResponse>('userInformation', userappPatchRequest)
        return response.data
    }
}

export const commonInitializationService = new CommonInitializationService()
